/* eslint-disable no-param-reassign */
import axios from 'axios';
import Vue from 'vue';
import Qs from 'qs';
import Cookies from 'js-cookie';
import eventBus, { REMOVE_REQUEST_MESSAGES, SHOW_MESSAGE } from '../util/eventBus';
import i18n from '../translations/i18n';

export function getRequestKey(config) {
  return `${config.method}:${config.url}`;
}

function removeEmptyFilters(params) {
  const updatedParams = {};
  Object.keys(params).forEach((key) => {
    if (typeof params[key] === 'boolean' || params[key]) {
      updatedParams[key] = params[key];
    }
  });
  return updatedParams;
}

// recursively sets all empty strings, empty objects and empty arrays to null
function removeEmptyFields(object) {
  let hasData = false;
  if (!object) {
    return hasData;
  }

  if (object.length) {
    // object is array
    for (let i = 0; i < object.length; i += 1) {
      let value = object[i];

      if (typeof value === 'string') {
        value = value.trim();
      }

      if (typeof value === 'object') {
        const hasChildData = removeEmptyFields(value);
        if (hasChildData) {
          hasData = true;
        } else {
          object[i] = null;
        }
      } else if (value !== '') {
        hasData = true;
      } else {
        object[i] = null;
      }
    }
  } else {
    // object is object
    const keys = Object.keys(object);
    for (let i = 0; i < keys.length; i += 1) {
      let value = object[keys[i]];

      if (typeof value === 'string') {
        value = value.trim();
      }

      if (typeof value === 'object') {
        const hasChildData = removeEmptyFields(value);
        if (hasChildData) {
          hasData = true;
        } else {
          object[keys[i]] = null;
        }
      } else if (value !== '') {
        hasData = true;
      } else {
        object[keys[i]] = null;
      }
    }
  }

  return hasData;
}

const httpClient = axios.create({
  baseURL: window.vueAppConfig.apiEndpoint,
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'repeat' });
  },
});

httpClient.interceptors.request.use((config) => {
  const accessToken = Vue.prototype.$keycloak?.token || Cookies.getJSON('accessToken');
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  config.headers.locale = i18n.locale;

  if (config.params) {
    config.params = removeEmptyFilters(config.params);
  }

  if (config.data) {
    removeEmptyFields(config.data);
  }

  eventBus.$emit(REMOVE_REQUEST_MESSAGES, getRequestKey(config));
  return config;
});

httpClient.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (!error.response?.status) {
      throw error;
    }
    switch (error.response.status) {
      case 400:
      case 401:
        eventBus.$emit(SHOW_MESSAGE, {
          type: 'error',
          requestKey: getRequestKey(error.response.config),
          text:
            typeof error.response?.data === 'string'
              ? error.response.data
              : i18n.t('messages.accessDenied'),
        });
        throw error;
      case 500: {
        try {
          const errors = error.response?.data?.error;
          if (errors?.length) {
            errors.forEach((e) => {
              if (!e.field) {
                eventBus.$emit(SHOW_MESSAGE, {
                  type: 'error',
                  requestKey: getRequestKey(error.response.config),
                  text: e.message,
                });
              }
            });
          }
        } catch (e) {
          console.log(e);
        }
        throw error;
      }
      default: {
        throw error;
      }
    }
  }
);

export default httpClient;
